<div class="modal-content text-center">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body pb-5">
        <h3 class="">Derivando atención</h3>
        <h6>Seleccione los campos necesarios para derivar su atención</h6>
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">
            <form [formGroup]="derivarForm" (ngSubmit)="onSubmitDerivar()">
                <div class="col-12">
                    <p>Seleccione la serie de atención a la que redirigirá este turno</p>
                </div>
                <div class="col-10 offset-1 mb-4">
                    <select formControlName="serie" class="text-center">
                    <option value="null" disabled>Seleccione serie</option>
                    <option *ngFor="let serie of seriesADerivar" [ngValue]="serie">{{serie.serie}}</option>
                  </select>
                    <div *ngIf="derivarIsSubmitted && derivarForm.get('serie')!.errors">
                        <div *ngIf="derivarForm.get('serie')!.errors!.required">
                            <small class="text-danger">Debe seleccionar una serie.</small>
                        </div>
                    </div>
                </div>


                <div class="col-12">
                    <p>Indique acción a seguir luego de derivar el turno</p>
                    <!-- <button class="check-prioritario ok-prioritario">
                <i class="fas fa-check-circle"></i> SI
              </button>
                    <button class="check-prioritario cancel-prioritario">
                <i class="fas fa-times-circle"></i> NO
              </button>
                    <div class="btn-group radio-group mb-4" role="group">
                        <label class="btn btn-outline-secondary btn1" for="btnradio1">
                          <input type="radio" class="btn-check" formControlName="accion" ng-value="1" name="btnradio1" [checked]="true" >
                        Continuar Atención</label>

                        <input type="radio" class="btn-check" formControlName="accion" ng-value="2" name="btnradio2" autocomplete="off">
                        <label class="btn btn-outline-secondary btn2" for="btnradio2">Pausar</label>

                        <input type="radio" class="btn-check" formControlName="accion" ng-value="3" name="btnradio3" autocomplete="off">
                        <label class="btn btn-outline-secondary btn3" for="btnradio3">Cerrar Sesión</label>
                    </div> -->
                    <div class="col-10 offset-1 mb-4">
                        <select formControlName="accion" class="text-center">
                          <option ngValue="1">Continuar Atención</option>
                          <option ngValue="2">Pausar</option>
                          <option ngValue="3">Cerrar Sesión</option>
                        </select>
                        <div *ngIf="derivarIsSubmitted && derivarForm.get('accion')!.errors">
                            <div *ngIf="derivarForm.get('accion')!.errors!.required">
                                <small class="text-danger">Debe seleccionar una acción.</small>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-12 text-center">
                    <button type="button" class="btn-color" type="submit">DERIVAR ATENCIÓN</button>
                </div>
            </form>
            <div class="col-12 mt-4">
                <a type="button" (click)="closeModal()">Volver</a>
            </div>
        </div>
    </div>
</div>